var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M20.037 16.623L14.455 11l5.585-5.627a.424.424 0 0 0 0-.598L16.26.967a.418.418 0 0 0-.593 0L10.08 6.594 4.497.971a.417.417 0 0 0-.594 0L.123 4.777a.426.426 0 0 0 0 .599L5.707 11l-5.58 5.621a.426.426 0 0 0 0 .598l3.782 3.808c.004.005.007.01.011.012.164.165.418.154.582-.012l5.58-5.621 5.581 5.623c.164.165.43.165.594 0l3.78-3.808c.005-.004.01-.008.012-.012a.412.412 0 0 0-.012-.586z"}));
}

IconClose.defaultProps = {"width":"21","height":"22","viewBox":"0 0 21 22"};

module.exports = IconClose;

IconClose.default = IconClose;
